import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getInVoicePdfUrl } from "../../store/actions/orderAction";
import {Receipt as ReceiptIcon } from '@mui/icons-material';
// Define the types for the props
interface InvoiceDownloadButtonProps {
  orderData: any;
  isDownload: boolean;
}

const InvoiceDownloadButton: React.FC<InvoiceDownloadButtonProps> = ({
  orderData,
  isDownload,
}) => {

 
  const dispatch: any = useDispatch();
   const {isLoading} = useSelector((state: any) => state.order)
   const [downLoading, setDownLoading] = useState<Boolean>(false)
  //  const handleDownloadBtnClick = () => {
  //   setLoading (true);
  //   setTimeout (() => {
  //     setLoading(true);
  //   },2000);
  //  };
   useEffect(() => {
    if(!isLoading){
      setDownLoading(isLoading)
    }
   }, [isLoading])
   
  const handleClick = (e:any) => {
    e.preventDefault();
    setDownLoading(true)
    const orderId = { orderId: orderData };
    dispatch(getInVoicePdfUrl(orderId)).then((pdfData: any) => {
      const fileUrl = pdfData?.pdfUrl;
      window.open(fileUrl, "_blank");
      // if (isDownload) {
      //   const link = document.createElement("a");
      //   link.href = fileUrl;
      //   link.download = fileUrl.split("/").pop() || "invoice.pdf";
      // } else {
      //   window.open(fileUrl, "_blank");
      // }
    });
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleClick}
     >
      <ReceiptIcon />&nbsp;&nbsp;
      {downLoading ? (
        <>
          Downloading
          <CircularProgress size={24} color="inherit" style={{ marginLeft: 8 }} /> 
        </>
      ) : (
        "Download Invoice"
      )}
    </Button>
  );
};

export default InvoiceDownloadButton;
